export default {
    clip_request_url: "Url de la miniatura",
    clip_request_transaction_id: "Id de transacción",
    clip_request_clip_date: "Fecha del clip",
    clip_request_upload_type: "Tipo de carga",
    clip_request_status: "Estado",
    clip_request_time_frame: "Duración",
    clip_request_driver: "Conductor",
    clip_request_unit: "Unidad",
    clip_request_requestor: "Solicitante",
    clip_request_error_msg: "Mensaje de error",
    clip_request_new_clip: "Nuevo Clip",
}